import React from "react";

/**
 * <DropDown description="Choose city of interest" array={arr} onClick={(e) => this.onLocationChangeHandler(e)} />
 */
class DropDown extends React.Component {

	constructor(props) {
		super(props);
		// this.arr = this.props.array;
		this.description = this.props.description;
		if (this.description === '') this.description = 'Choose';
		this._onclickHandler = this.props.onClick;
		this.state = {
			description: this.description,
		}
	}

	handleChange(e) {
		e.preventDefault();
		// console.log(e);
		const value = e.currentTarget.dataset.value;
		// console.log(value);
		this._onclickHandler(e);
		// this._onclickHandler(value);
		this.setState({
			description: value,
		});
	}

	render() {
		return (
			<>
				<div className="dropdown">
					<button className="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						{this.state.description}
					</button>
					<div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
						{
							this.props.array.map((value, key) =>
								<a
									key={key}
									className="dropdown-item"
									// TODO: [mck] add active class
									data-value={value}
									href={"#" + value}
									onClick={(e) => this.handleChange(e)}>{value}</a>
							)
						}
					</div>
				</div>
			</>
		);
	}
}

export default DropDown;